import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import moduleCommon from './common/'
import moduleOrder from './order/'
import modulelrpOrder from './lrporder/'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common: moduleCommon,
    order:moduleOrder,
    lrporder:modulelrpOrder
  },
  plugins: [
    createPersistedState({ key: 'dvs-common', paths: ['common'] }),
    createPersistedState({ key: 'dvs-order', paths: ['order'] }),
    createPersistedState({ key: 'dvs-lrporder', paths: ['lrporder'] }),
  ]
})
